module.exports = __webpack_public_path__ + "static/profil1-70f820d22a3ea56155088bd856183249.png";